(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["feature-slider"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    function initSlider(wrap) {
      var track   = wrap.querySelector('.feature-slider__track');
      var slides  = Array.from(track.querySelectorAll('.feature-slider__slide'));
      var nav     = wrap.closest('.feature-slider__media').querySelector('.feature-slider__nav');
      var bars    = nav ? Array.from(nav.querySelectorAll('.feature-slider__bar')) : [];
      var speed   = parseInt(wrap.dataset.autoplay, 10) * 1000;
      var count   = slides.length;
      var current = 0;
      var timer   = null;
      var dragging = false;
      var dragStartX = 0;
      var dragStartTime = 0;

      if (count <= 1) return;

      function getStep() {
        var slide = slides[0];
        var style = window.getComputedStyle(track);
        var gap   = parseFloat(style.columnGap || style.gap) || 20;
        return slide.offsetWidth + gap;
      }

      function goTo(index) {
        current = ((index % count) + count) % count;
        track.style.transform = 'translateX(-' + (current * getStep()) + 'px)';
        bars.forEach(function (bar, i) {
          bar.classList.toggle('is-active', i === current);
        });
      }

      function next() { goTo(current + 1); }
      function prev() { goTo(current - 1); }

      function startAuto() {
        if (speed > 0) timer = setInterval(next, speed);
      }
      function stopAuto() { clearInterval(timer); timer = null; }

      /* Bar clicks */
      bars.forEach(function (bar, i) {
        bar.addEventListener('click', function () {
          stopAuto(); goTo(i); startAuto();
        });
      });

      /* Pause on hover */
      wrap.addEventListener('mouseenter', stopAuto);
      wrap.addEventListener('mouseleave', function () {
        if (!dragging) startAuto();
      });

      /* Touch + mouse drag */
      function onDragStart(x) {
        dragging = true;
        dragStartX = x;
        dragStartTime = Date.now();
        stopAuto();
        track.style.transition = 'none';
      }
      function onDragEnd(x) {
        if (!dragging) return;
        dragging = false;
        track.style.transition = '';
        var diff = dragStartX - x;
        var elapsed = Date.now() - dragStartTime;
        var isFlick = Math.abs(diff) > 30 && elapsed < 300;
        if (isFlick || Math.abs(diff) > wrap.offsetWidth * 0.25) {
          diff > 0 ? next() : prev();
        } else {
          goTo(current); /* snap back */
        }
        startAuto();
      }

      /* Touch */
      track.addEventListener('touchstart', function (e) {
        onDragStart(e.touches[0].clientX);
      }, { passive: true });
      track.addEventListener('touchmove', function (e) {
        if (!dragging) return;
        var dx = dragStartX - e.touches[0].clientX;
        track.style.transform = 'translateX(-' + (current * getStep() + dx) + 'px)';
      }, { passive: true });
      track.addEventListener('touchend', function (e) {
        onDragEnd(e.changedTouches[0].clientX);
      }, { passive: true });

      /* Mouse drag */
      track.addEventListener('mousedown', function (e) {
        onDragStart(e.clientX);
        e.preventDefault();
      });
      document.addEventListener('mousemove', function (e) {
        if (!dragging) return;
        var dx = dragStartX - e.clientX;
        track.style.transform = 'translateX(-' + (current * getStep() + dx) + 'px)';
      });
      document.addEventListener('mouseup', function (e) {
        if (dragging) onDragEnd(e.clientX);
      });

      /* Re-snap on resize */
      var resizeTimer;
      window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () { goTo(current); }, 150);
      });

      goTo(0);
      startAuto();
    }

    document.querySelectorAll('.feature-slider__slider-wrap').forEach(initSlider);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["field-guide-feature"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    function initStack(section) {
      var slides = Array.from(section.querySelectorAll('.fg-stack__slide'));
      var count = slides.length;
      if (count < 2) return;

      var autoplaySpeed = parseInt(section.dataset.autoplay || '0', 10) * 1000;
      var current = 0;
      var busy = false;
      var timer = null;

      function getClass(idx, exitingIdx) {
        if (exitingIdx !== undefined && idx === exitingIdx) return 'fg-stack__slide--exiting';
        if (idx === current) return 'fg-stack__slide--active';
        if (idx === (current + 1) % count) return 'fg-stack__slide--behind-1';
        if (idx === (current + 2) % count) return 'fg-stack__slide--behind-2';
        return 'fg-stack__slide--hidden';
      }

      function apply(exitingIdx) {
        slides.forEach(function (slide, i) {
          slide.className = 'fg-stack__slide ' + getClass(i, exitingIdx);
        });
      }

      function goTo(next) {
        if (busy) return;
        busy = true;
        var old = current;
        current = ((next % count) + count) % count;

        // Phase 1: animate current card off-screen, shift others into new positions.
        // The exiting card steals the behind-2 slot when count=3, so phase 2 fixes it.
        apply(old);

        setTimeout(function () {
          // Phase 2: snap the exited card to its correct position instantly (no transition)
          // so it reappears already in place under the stack without animating in.
          var oldCard = slides[old];
          oldCard.style.transition = 'none';
          apply(); // full re-classify — no exitingIdx, behind-2 properly assigned
          oldCard.getBoundingClientRect(); // force reflow before restoring transition
          oldCard.style.transition = '';
          busy = false;
        }, 500);
      }

      function next() { goTo(current + 1); }
      function prev() { goTo(current - 1); }

      function startAuto() {
        if (autoplaySpeed > 0 && !timer) timer = setInterval(next, autoplaySpeed);
      }
      function stopAuto() { clearInterval(timer); timer = null; }

      var prevBtn = section.querySelector('.fg-stack__prev');
      var nextBtn = section.querySelector('.fg-stack__next');
      if (prevBtn) prevBtn.addEventListener('click', function () { stopAuto(); prev(); startAuto(); });
      if (nextBtn) nextBtn.addEventListener('click', function () { stopAuto(); next(); startAuto(); });

      var cards = section.querySelector('.fg-feature__cards');
      if (cards) {
        cards.addEventListener('mouseenter', stopAuto);
        cards.addEventListener('mouseleave', function () { if (!busy) startAuto(); });

        /* Touch swipe */
        var touchStartX = 0;
        cards.addEventListener('touchstart', function (e) {
          touchStartX = e.touches[0].clientX;
        }, { passive: true });
        cards.addEventListener('touchend', function (e) {
          var diff = touchStartX - e.changedTouches[0].clientX;
          if (Math.abs(diff) > 40) {
            stopAuto();
            diff > 0 ? next() : prev();
            startAuto();
          }
        }, { passive: true });
      }

      apply();
      startAuto();
    }

    document.querySelectorAll('.fg-feature').forEach(initStack);
  })();

  } catch(e) { console.error(e); }
})();
})();
